import { render, staticRenderFns } from "./BasicInfoSection.vue?vue&type=template&id=5aeba684&"
import script from "./BasicInfoSection.vue?vue&type=script&lang=js&"
export * from "./BasicInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports